import React, { useMemo } from 'react';
import './CompatibleLenses.scss';
import { useSelector } from 'react-redux';
import { v4 } from 'uuid';
import Collapse from '../Collapse/Collapse';

const TechnicalDetails = ({ thumbnailImage, isAccessories }) => {
  const localeInfo = useSelector(state => state.common.localeInfo);
  const pid = useSelector(state => state.common.productID);
  const dataLocale = useSelector(state => state.locale);

  const {
    COMPATIBLE_LENSES_ONLINE_STORE,
    LENSES_BLUE_LIGHT,
    COLOUR_LENSES,
    HIGH_INDEX_ASPHERIC_LENSES,
    TRANSITIONS_LENSES,
    TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
    PLEASE_NOTE_PROGRESSIVE_GLASSES_NOT_AVAILABLE_FOR_PURCHASE,
  } = dataLocale;

  const compatibleLensesButtons = useMemo(() => {
    return [
      {
        title: LENSES_BLUE_LIGHT,
        href: '#',
      },
      {
        title: COLOUR_LENSES,
        href: '#',
      },
      {
        title: HIGH_INDEX_ASPHERIC_LENSES,
        href: '#',
      },
      {
        title: TRANSITIONS_LENSES,
        href: '#',
      },
      {
        title: TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
        href: '#',
      },
    ];
  }, [
    COLOUR_LENSES,
    HIGH_INDEX_ASPHERIC_LENSES,
    LENSES_BLUE_LIGHT,
    TRANSITIOND_LIGHT_INTELLIGENT_LENSES,
    TRANSITIONS_LENSES,
  ]);

  const handleCompatibleLensesClick = link => {
    window.location.assign(link);
  };

  return (
    <div className={`compatible-lenses ${isAccessories ? 'hidden' : ''}`}>
      <Collapse title={COMPATIBLE_LENSES_ONLINE_STORE}>
        <ul className="compatible-lenses__list">
          {compatibleLensesButtons.map(el => {
            return <li key={v4()}>{el?.title}</li>;
          })}
        </ul>
        <button
          className="odButton odButton--outline"
          onClick={() => handleCompatibleLensesClick('/sg/en/services/lens')}
        >
          DETAILED LENS GUIDE
          <img
            alt=""
            loading="lazy"
            src="https://static.lenskart.com/owndays/img/icons/chevron-right.svg"
          />
        </button>
        <ul className="compatible-lenses__notes">
          <li>{PLEASE_NOTE_PROGRESSIVE_GLASSES_NOT_AVAILABLE_FOR_PURCHASE}</li>
        </ul>
      </Collapse>
    </div>
  );
};

export default TechnicalDetails;
